module.exports = __webpack_public_path__ + "img/slider_comments_6.96f35d9e.jpg";